import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeRedirectGuardService } from './shared/guards/home-redirect-guard.service';

export const routes: Routes = [
  { path: '', redirectTo: '/account/login', pathMatch: 'full' },
  { path: 'home', children: [], pathMatch: 'full', canActivate: [HomeRedirectGuardService] },
  {
    path: 'account',
    loadChildren: () => import('./login/login.module').then((mod) => mod.LoginModule),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then((mod) => mod.DashboardModule),
    canActivate: [HomeRedirectGuardService],
    pathMatch: 'prefix',
  },
  {
    path: 'referencer',
    loadChildren: () =>
      import('./referencer/referencer.module').then((mod) => mod.ReferencerModule),
    canActivate: [HomeRedirectGuardService],
    pathMatch: 'prefix',
  },
  {
    path: 'tracker',
    loadChildren: () => import('./tracker/tracker.module').then((mod) => mod.TrackerModule),
    canActivate: [HomeRedirectGuardService],
    pathMatch: 'prefix',
  },
  {
    path: 'contributor',
    loadChildren: () =>
      import('./contributor/contributor.module').then((mod) => mod.ContributorModule),
    canActivate: [HomeRedirectGuardService],
    pathMatch: 'prefix',
  },
  {
    path: 'contributorV2',
    loadChildren: () =>
      import('./contributorV2/contributorV2.module').then((mod) => mod.ContributorV2Module),
    canActivate: [HomeRedirectGuardService],
    pathMatch: 'prefix',
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then((mod) => mod.AdminModule),
    canActivate: [HomeRedirectGuardService],
    pathMatch: 'full',
  },
  {
    path: 'administrator',
    loadChildren: () =>
      import('./administrator/administrator.module').then((mod) => mod.AdministratorModule),
    canActivate: [HomeRedirectGuardService],
    pathMatch: 'full',
  },
  {
    path: 'validator',
    loadChildren: () => import('./validator/validator.module').then((mod) => mod.ValidatorModule),
    canActivate: [HomeRedirectGuardService],
    pathMatch: 'prefix',
  },
  {
    path: 'technicalAdministrator',
    loadChildren: () =>
      import('./technicalAdministrator/technicalAdministrator.module').then(
        (mod) => mod.TechnicalAdministratorModule,
      ),
    canActivate: [HomeRedirectGuardService],
    pathMatch: 'prefix',
  },
  {
    path: 'error',
    loadChildren: () => import('./error/error.module').then((mod) => mod.ErrorModule),
    pathMatch: 'prefix',
  },
  { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
